export default __webpack_public_path__ + "static/htmlcss-10e93d02793ec0609b77ae0129490b4c.jpg";